import React from 'react';

import PropTypes from 'prop-types';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { DocumentTextIcon } from '@adsk/alloy-react-icon';
import Theme from '@adsk/alloy-react-theme';

import { isBuildPro } from './helpers/formatEntities';
import EntityMenuItem from '../../EntityMenuItem';

const DocsEntityMenuItem = ({ entity, ...rest }) => {
  const projectId = useCurrentProjectId();

  const { urn, parentFolderUrn, name } = entity;
  const url = `/${
    isBuildPro() ? 'build' : 'docs'
  }/files/projects/${projectId}?entityId=${urn}&folderUrn=${parentFolderUrn}&moduleId=folders`;

  const label = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ paddingLeft: 6, color: Theme.colors.charcoal900 }}>
        {name}
      </span>
    </div>
  );

  return (
    <EntityMenuItem
      link={url}
      label={label}
      renderIcon={(p) => <DocumentTextIcon {...p} />}
      {...rest}
    />
  );
};

DocsEntityMenuItem.propTypes = {
  entity: PropTypes.shape({
    urn: PropTypes.string,
    parentFolderUrn: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};

export default DocsEntityMenuItem;
